module.exports = __webpack_public_path__ + "img/free-piggy.cf4fcb3.webp";